import React from 'react'

import { InsightCard, ViewMoreMicroCard } from '..'
import type { MicroInsightCardProps } from '../interfaces'

import { useCopyStore } from '../context/hooks'

import type { Beat } from '../../core/types/Beat'
import { buildDynamicCopy } from '../../core/utils/Localization'

export interface BeatListProps extends MicroInsightCardProps {
  activeCardIndex: number
  beats: Beat[]
  cardWidth: number | null
}

const BeatList: React.FC<BeatListProps> = ({
  activeCardIndex,
  beats,
  cardWidth,
  elevation,
  heightOverrides,
  onCardClick,
  posthog,
  showIcon,
  variant,
}) => {
  const { carouselCopy: copy } = useCopyStore()

  const generalProps = {
    elevation,
    heightOverrides,
    posthog,
    showIcon,
    variant,
  }

  return (
    <>
      {beats.map((beat: Beat, i) => {
        const beatPosition = i + 1
        const totalBeats = beats.length + 1
        const ariaLabelPositionInCarousel = buildDynamicCopy(
          copy?.card_position_in_carousel_aria,
          beatPosition.toString(),
          totalBeats.toString(),
        )

        const hasMicroTitle = beat.micro_title && beat.micro_title.length > 0
        const hasMicroDescription = beat.micro_description && beat.micro_description.length > 0

        const beatTitle = hasMicroTitle ? beat.micro_title : beat.title
        const beatDescription = hasMicroDescription ? beat.micro_description : beat.description

        return (
          <InsightCard
            ariaLabel={`${ariaLabelPositionInCarousel}: ${beatTitle}, ${beatDescription}`}
            beat={beat}
            index={i}
            isActiveCard={i === activeCardIndex}
            key={`${beat.guid} ${i}`}
            onCardClick={onCardClick}
            widthOverrides={cardWidth || undefined}
            {...generalProps}
          />
        )
      })}
      <ViewMoreMicroCard
        isActiveCard={activeCardIndex === beats.length}
        onCardClick={onCardClick}
        widthOverrides={cardWidth || undefined}
        {...generalProps}
      />
    </>
  )
}

export default BeatList
